import { render, staticRenderFns } from "./formGenerateOrder.vue?vue&type=template&id=7acd7bfd"
import script from "./formGenerateOrder.vue?vue&type=script&lang=js"
export * from "./formGenerateOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7acd7bfd')) {
      api.createRecord('7acd7bfd', component.options)
    } else {
      api.reload('7acd7bfd', component.options)
    }
    module.hot.accept("./formGenerateOrder.vue?vue&type=template&id=7acd7bfd", function () {
      api.rerender('7acd7bfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/router/components/form/formGenerateOrder.vue"
export default component.exports